import { gql } from '@apollo/client'

export const SET_CUSTOMER_SPREEDLY_CARD_AS_PRIMARY = gql`
  mutation SetCustomerSpreedlyCardAsPrimary($input: SetCustomerSpreedlyCardAsPrimaryInput!) {
    setAsPrimaryCustomerSpreedlyCard(input: $input) {
      customerSpreedlyCard {
        id
        primary
      }
    }
  }
`
